import Swal from "sweetalert2";

export const attachmentErrorAlert = (text) => {
  console.log("Attachment Error Alert Triggered:", text);
  return Swal.fire({
    icon: "error",
    title: '<span style="color: #FF7D95;">Attachments Upload Failed</span>',
    html: `<span style="color: #6E6996;">${text}</span>`,
  });
};
